import React from "react";
import {ClientManagementLayout} from "../../layouts/ClientManagementLayout";
import {Pane} from "evergreen-ui";
import {reduceRelayPaginationAction, RelayPaginationActionPayload, RelayPaginationState} from "providerapp/pagination";
import {SortBy} from "common";
import {AuthorizationInfo} from "../domain";
import {SortOrder} from "../../../placement/domains";
import {ClientOfferAtRiskList} from "./ClientOfferAtRiskList";
import {tryFormatLocalDate} from "common/util/date";
import {SPLIT_DELIMITER} from "../../../placement/const";

const defaultPageSize = 10;

export type ClientOfferAtRiskPageAction =
    | { type: 'SET_SORT_BY'; sortBy: SortBy<AuthorizationInfo> }
    | { type: 'SET_FILTER'; filter: ClientOfferAtRiskFilterValue }
    | { type: 'SET_SEARCH'; search: string }
    | { type: 'SET_PAGE_SIZE'; pageSize: number }
    | RelayPaginationActionPayload

export interface ClientOfferAtRiskPageState {
    pagination: RelayPaginationState;
    filter: ClientOfferAtRiskFilterValue;
    pageSize: number;
    search: string;
    sortBy: SortBy<AuthorizationInfo>;
}

function initState(): ClientOfferAtRiskPageState {
    const defaultPagination = new RelayPaginationState('0', defaultPageSize)
    return {
        pagination: defaultPagination,
        pageSize: defaultPagination.size,
        search: "",
        filter: {
            cities: "",
            fromDate: null,
            toDate: null,
        },
        sortBy: {
            column: "client.fullName",
            order: SortOrder.ASC,
        }
    }
}

function reducer(
    state: ClientOfferAtRiskPageState,
    action: ClientOfferAtRiskPageAction
): ClientOfferAtRiskPageState {

    switch (action.type) {
        case "SET_SORT_BY":
            return {
                ...state,
                sortBy: action.sortBy
            };
        case 'RELAY_PAGINATION_ACTION':
            return {
                ...state,
                pagination: reduceRelayPaginationAction(state.pagination, action)
            };
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
                pagination: new RelayPaginationState('0', state.pageSize),
            }
        case 'SET_SEARCH':
            return {
                ...state,
                search: action.search,
                pagination: new RelayPaginationState('0', state.pageSize),
            }
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
                pagination: new RelayPaginationState('0', action.pageSize)
            }

        default:
            return state;
    }
}

export type  ClientOfferAtRiskFilterValue = {
    cities: string;
    fromDate: Date | null;
    toDate: Date | null;
}

export function asQueryParam(filter: ClientOfferAtRiskFilterValue, searchText: string) {
    return {
        cities: filter.cities === "" ?
            [] :
            filter.cities.split(SPLIT_DELIMITER).filter((city) => city !== ""),
        search: searchText !== "" ? searchText : null,
        fromResponseDueDate: tryFormatLocalDate(filter.fromDate ?? null),
        toResponseDueDate: tryFormatLocalDate(filter.toDate ?? null),
    };
}

export const ClientOfferAtRiskPage = () => {
    const [{
        pagination,
        sortBy,
        filter,
        search,
        pageSize,
    }, dispatch] = React.useReducer(reducer, initState());

    return (
        <ClientManagementLayout customSelection={'Client Offers - At Risk'}>
            <Pane minHeight="calc(100vh - 100px - 260px - 36px)" flexGrow={1}>
                <ClientOfferAtRiskList dispatch={dispatch}
                                       pageSize={pageSize}
                                       pagination={pagination}
                                       searchText={search}
                                       sortBy={sortBy}
                                       filter={filter}
                />
            </Pane>
        </ClientManagementLayout>
    );
}
